import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE } from "@/lib/api";
import axios from "axios";

const LANGS = [
  { code: "it", label: "IT", flag: "🇮🇹" },
  { code: "en", label: "EN", flag: "🇬🇧" },
  { code: "de", label: "DE", flag: "🇩🇪" },
];

const uiCopy = {
  it: { loading: "Caricamento…", from: "Prodotti tipici sardi", curr: "EUR", empty: "Menu in aggiornamento" },
  en: { loading: "Loading…", from: "Typical Sardinian products", curr: "EUR", empty: "Menu being updated" },
  de: { loading: "Wird geladen…", from: "Typische sardische Produkte", curr: "EUR", empty: "Speisekarte wird aktualisiert" },
};

export default function PublicMenu() {
  const { lang: langParam } = useParams();
  const navigate = useNavigate();
  const lang = ["it", "en", "de"].includes(langParam) ? langParam : "it";
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`${API_BASE}/public/menu?lang=${lang}`);
      setData(data);
    })();
  }, [lang]);

  const t = uiCopy[lang];

  return (
    <div className="min-h-screen bg-[#FDFBF7] text-neutral-900" data-testid="public-menu">
      {/* Language switcher */}
      <div className="sticky top-0 z-10 border-b border-[#E2D9C8] bg-[#FDFBF7]/95 backdrop-blur">
        <div className="max-w-2xl mx-auto px-6 py-3 flex justify-between items-center">
          <img src="/logo-carasau-dark.png" alt="Carasau Café" className="h-14 w-auto" />
          <div className="flex gap-1">
            {LANGS.map((l) => (
              <button key={l.code} data-testid={`lang-${l.code}`} onClick={() => navigate(`/m/${l.code}`)}
                className={`text-xs px-3 py-1.5 rounded-full transition-colors ${l.code === lang ? "bg-neutral-900 text-[#FDFBF7]" : "hover:bg-[#F3EDE1]"}`}>
                {l.flag} {l.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-6 py-10">
        {/* Hero */}
        <div className="text-center mb-12">
          <div className="label-eyebrow">Orosei · Sardegna</div>
          <img src="/logo-carasau-dark.png" alt="Carasau Café" className="w-64 h-auto mx-auto mt-4" />
          <p className="mt-6 text-neutral-500 max-w-md mx-auto">{t.from}</p>
          <div className="mt-6 mx-auto w-16 h-px bg-[#D7C4A3]" />
        </div>

        {!data && <div className="text-center text-neutral-500">{t.loading}</div>}

        {data && Object.entries(data.categories).length === 0 && (
          <div className="text-center text-neutral-500">{t.empty}</div>
        )}

        {data && Object.entries(data.categories).map(([cat, items]) => (
          <section key={cat} className="mb-12" data-testid={`cat-${cat}`}>
            <div className="flex items-center gap-4 mb-6">
              <h2 className="font-serif text-3xl italic capitalize">{cat}</h2>
              <div className="flex-1 h-px bg-[#E2D9C8]" />
            </div>
            <div className="space-y-6">
              {items.map((it) => (
                <div key={it.id} className="flex items-baseline gap-3" data-testid={`menu-item-${it.id}`}>
                  <div className="flex-1">
                    <div className="font-serif text-xl leading-tight">{it.name}</div>
                    {it.description && <div className="text-sm text-neutral-500 mt-1">{it.description}</div>}
                  </div>
                  <div className="border-b border-dotted border-[#D7C4A3] flex-1 mb-1" />
                  <div className="font-serif text-xl tabular-nums whitespace-nowrap">€ {it.price?.toFixed(2)}</div>
                </div>
              ))}
            </div>
          </section>
        ))}

        <footer className="mt-16 pt-8 border-t border-[#E2D9C8] text-center text-xs text-neutral-500">
          <img src="/logo-carasau-dark.png" alt="Carasau Café" className="h-14 w-auto mx-auto mb-3 opacity-70" />
          <div>Orosei · Sardegna · Italia</div>
        </footer>
      </div>
    </div>
  );
}
